import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers/root/rootreducer';
//import loggerMiddleware from 'redux-logger';
import { createLogger } from 'redux-logger';

import { routerMiddleware } from 'react-router-redux'

export default function configureStore(history, initialState) {
    //const logger = loggerMiddleware();
    const logger = createLogger();
    const reactReduxRouterMiddleware = routerMiddleware(history);

    const middlewares = [
        thunkMiddleware,
        reactReduxRouterMiddleware
    ];

    const isOnServer = typeof(window) === "undefined"; // to avoid having the store-updates spam the servers stdout (almost always makes debugging the server output harder, since there is so much noise in stdout)
    if (clientConfig.config.debug_logging && !isOnServer) {
        middlewares.push(logger);
    }

    const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);

    return createStoreWithMiddleware(rootReducer, initialState);
};



// WEBPACK FOOTER //
// ./src/client/src/store/configurestore.js